import { createUseTrackScreen } from '@bluecodecom/tracking';

import { ScreenName, TrackingEvents, trackingService } from '../../service';

/**
 * Reports a displayed screen twice — the catalogued universal `screen_displayed`
 * and this app's legacy `<Screen>: Opened` — for as long as the migration needs
 * both (catalog rule `dual-fire`).
 *
 * Pass a nullish screen name for a render that is not going to display the
 * screen; both events are then suppressed together.
 */
const useTrackScreen = createUseTrackScreen<ScreenName, TrackingEvents>(
  trackingService,
);

export default useTrackScreen;
